module.exports = __webpack_public_path__ + "assets/images/7ce4ef79f950e718f6b7c00d610b8cad.png";